import { AlertTriangle, RefreshCw } from 'lucide-react';
import type { AppLanguage, FriendlyError } from './user-errors';

type Props = {
  error: FriendlyError | string | null | undefined;
  lang: AppLanguage;
  onRetry?: () => void;
};

export function UserErrorNotice({ error, lang, onRetry }: Props) {
  if (!error) return null;
  const content = typeof error === 'string'
    ? {
        title: lang === 'ur' ? 'درج کردہ معلومات چیک کریں' : 'Please check the information entered',
        message: error,
      }
    : error;

  return <div className="user-error-notice" role="alert" aria-live="polite">
    <span className="user-error-icon"><AlertTriangle aria-hidden="true" /></span>
    <div className="user-error-copy">
      <strong>{content.title}</strong>
      <p>{content.message}</p>
    </div>
    {onRetry && <button type="button" onClick={onRetry}>
      <RefreshCw aria-hidden="true" />
      {lang === 'ur' ? 'دوبارہ کوشش کریں' : 'Try again'}
    </button>}
  </div>;
}
